import { GrTest } from 'react-icons/gr';
import { HiDocumentReport } from 'react-icons/hi';
import { RenderTiles } from '../../../components/common';
import ChildHeader from '../../../components/ui/ChildHeader';

export type tilesType = {
  sNo: number;
  link: string;
  isLink: boolean;
  isIcon: boolean;
  clauseNo?: string | number;
  p: string;
  span: string;
  icon?: any;
  style?: {};
}[];
const tiles = [
  {
    sNo: 1,
    // link: 'https://uc.secure.aqua.mushinlabs.com',
    isLink: true,
    // target: '_blank',
    link: '/common/tniTiles',
    clauseNo: 5,
    icon: <HiDocumentReport size="5rem" color="#135089" />,
    p: 'TNI',
    span: '(TRAINING NEED IDENTIFICATION)',
    isIcon: true,
  },
  {
    sNo: 2,
    // link: 'https://uc.secure.aqua.mushinlabs.com',
    link: '/common/annualTrainingList',
    isLink: true,
    // target: '_blank',
    clauseNo: 5,
    icon: <HiDocumentReport size="5rem" color="#135089" />,
    p: 'TRAINING',
    span: 'PLAN',
    isIcon: true,
  },
  {
    sNo: 3,
    // link: 'https://uc.secure.aqua.mushinlabs.com',
    link: '/common/trainginStatusList',
    isLink: true,
    // target: '_blank',
    clauseNo: 5,
    icon: <HiDocumentReport size="5rem" color="#135089" />,
    p: 'TRAINING',
    span: 'STATUS',
    isIcon: true,
  },
];

const TrainingTniHome = () => {
  return (
    <>
      <ChildHeader text="TRAINING" />
      <RenderTiles tilesObj={tiles} height={'100vh'} justify="start" />
    </>
  );
};

export default TrainingTniHome;
